import React from 'react'
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    ListItem,
    List,
} from '@material-ui/core';
import { Link } from 'react-router-dom'
import { getPermissions } from 'mdoc/admin/axios';

const styles = theme => ({
    linkItem: {
        'textDecoration': 'none',
        'color': '#3C3C3C',
        '&:hover': {
            'textDecoration': 'none',
            'color': '#3C3C3C',
        },
        "paddingLeft": theme.spacing.unit * 5,
        'display': 'block',
        width: '100%',
        height: '100%',
    },
    linkItemSelected: {
        'textDecoration': 'none',
        'color': '#FFFFFF',
        '&:hover': {
            'textDecoration': 'none',
            'color': '#FFFFFF',
        },
        "paddingLeft": theme.spacing.unit * 5,
        'display': 'block',
        width: '100%',
        height: '100%',
    },
    primary: {},
    icon: {},
    customLiSelected: {
        backgroundColor: theme.palette.primary.main,
    },
    customLi: {
    },
    customLinkSelected: {
        color: '#fff',
    },
    customLink: {
    }
});

class SiderMenu extends React.Component {
    state = {
        selectedIndex: this.props.selectedkey,
    };

    handleListItemClick = (path) => event => {
        this.setState({ selectedIndex: path });
    };

    render() {
        const props = this.props;
        const { classes } = props;
        const permissions = getPermissions() ? getPermissions() : [];
        const renderMenuItem = (item, prop) => {
            if (item.first) {
                if (item.code === undefined) {
                    return (
                        <List component="nav" key={item.key}>
                            <ListItem
                                classes={{
                                    root: (this.state.selectedIndex === item.key) ? classes.customLiSelected : classes.customLi
                                }}
                            >
                                <Link
                                    onClick={this.handleListItemClick(item.key)}
                                    className={(this.state.selectedIndex === item.key) ? classes.linkItemSelected : classes.linkItem}
                                    to={item.key} replace={(this.state.selectedIndex === item.key) ? true : false}
                                    style={(item['subs']) ? {} : { paddingLeft: '0px' }}
                                >
                                    <span>{item.titleDictKey ? prop.commondict[item.titleDictKey] : item.title}</span>
                                </Link>
                            </ListItem>
                        </List>
                    );
                } else {
                    if (permissions.includes(item.code)) {
                        return (
                            <List component="nav" key={item.key}>
                                <ListItem
                                    classes={{
                                        root: (this.state.selectedIndex === item.key) ? classes.customLiSelected : classes.customLi
                                    }}
                                >
                                    <Link
                                        onClick={this.handleListItemClick(item.key)}
                                        className={(this.state.selectedIndex === item.key) ? classes.linkItemSelected : classes.linkItem}
                                        to={item.key} replace={(this.state.selectedIndex === item.key) ? true : false}
                                        style={(item['subs']) ? {} : { paddingLeft: '0px' }}
                                    >
                                        <span>{item.titleDictKey ? prop.commondict[item.titleDictKey] : item.title}</span>
                                    </Link>
                                </ListItem>
                            </List>
                        );
                    }
                }
            } else {
                if (item.code === undefined) {
                    return (
                        <ListItem
                            key={item.key}
                            className={classes.menuItem}
                            classes={{
                                root: (this.state.selectedIndex === item.key) ? classes.customLiSelected : classes.customLi
                            }}
                        >
                            <Link
                                onClick={this.handleListItemClick(item.key)}
                                className={(this.state.selectedIndex === item.key) ? classes.linkItemSelected : classes.linkItem}
                                to={item.route || item.key} replace={(this.state.selectedIndex === item.key) ? true : false}
                            >
                                <span>{item.titleDictKey ? prop.commondict[item.titleDictKey] : item.title}</span>
                            </Link>
                        </ListItem>
                    );
                } else {
                    if (permissions.includes(item.code)) {
                        return (
                            <ListItem
                                key={item.key}
                                className={classes.menuItem}
                                classes={{
                                    root: (this.state.selectedIndex === item.key) ? classes.customLiSelected : classes.customLi
                                }}
                            >
                                <Link
                                    onClick={this.handleListItemClick(item.key)}
                                    className={(this.state.selectedIndex === item.key) ? classes.linkItemSelected : classes.linkItem}
                                    to={item.route || item.key} replace={(this.state.selectedIndex === item.key) ? true : false}
                                >
                                    <span>{item.titleDictKey ? prop.commondict[item.titleDictKey] : item.title}</span>
                                </Link>
                            </ListItem>
                        );
                    }
                }
            }
        }

        const renderSubMenu = (item, prop) => {
            if (item.code === undefined) {
                return (
                    <List component="nav" key={item.key}>
                        <ListItem>
                            <span>{item.titleDictKey ? prop.commondict[item.titleDictKey] : item.title}</span>
                        </ListItem>
                        {item.subs.map(item => renderMenuItem(item, prop))}
                    </List>
                )
            } else {
                if (permissions.includes(item.code)) {
                    return (
                        <List component="nav" key={item.key}>
                            <ListItem>
                                <span>{item.titleDictKey ? prop.commondict[item.titleDictKey] : item.title}</span>
                            </ListItem>
                            {item.subs.map(item => renderMenuItem(item, prop))}
                        </List>
                    )
                }
            }
        }
        return (
            <div>
                {props.menus && props.menus.map(item =>
                    item.subs ? renderSubMenu(item, props) : renderMenuItem(item, props)
                )}
            </div>
        );
    }
}

SiderMenu.propTypes = {
    classes: PropTypes.object.isRequired,
    menus: PropTypes.array.isRequired,
    commondict: PropTypes.object.isRequired,
    openkey: PropTypes.string.isRequired,
    selectedkey: PropTypes.string.isRequired,
};

export default withStyles(styles)(SiderMenu);
